var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.64645 15.3536L9 15.7071L9.70711 15L9.35355 14.6464L5.20784 10.5007L16 10.5007L16.5 10.5007L16.5 9.50073L16 9.50073L5.20637 9.50073L9.35355 5.35355L9.70711 5L9 4.29289L8.64645 4.64645L3.64645 9.64645C3.45118 9.84171 3.45118 10.1583 3.64645 10.3536L8.64645 15.3536Z","fill":"#22202F"}));
}

ArrowLeft.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
